import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_SURVEY_SERVICE_BASE_URL;


export const getAllSurveys = async() => await axios.get(apiBaseUrl+'assessment/surveys/getAllSurveys');
export const getSurveyById = (surveyId: any) => axios.get(apiBaseUrl+'assessment/survey/'+surveyId);
export const getSurveyByIdV2 = (surveyId: any) => axios.get(apiBaseUrl+'assessment/v2/survey/'+surveyId);
export const getTeamsBySurveyGroupId = (surveyGroupId: any) => axios.get(apiBaseUrl+'assessment/survey-group/'+surveyGroupId+'/teams');
export const getSurveyResponseBySurveyId=(surveyId: any) => axios.get(apiBaseUrl+'assessment/survey/responses/'+surveyId);
export const postSurvey = (reqBody: any) => axios.post(apiBaseUrl+'assessment/survey', reqBody);
export const postSurveyResponse = (reqBody: any) => axios.post(apiBaseUrl+'assessment/survey/response',reqBody);
export const postSurveyResponseNew = (reqBody: any) => axios.post(apiBaseUrl+'assessment/survey/response/new',reqBody);
export const patchSurvey = (surveyId: any) => axios.patch(apiBaseUrl+'assessment/survey/'+surveyId);
export const surveyOtp = (otp?: any) => axios.post(apiBaseUrl+'assessment/otp', otp);
export const getAllSurveyGroups = () => axios.get(apiBaseUrl+'assessment/survey-groups');
export const generateSurveyGroupPdf = (surveyGroupId: any) => axios.get(apiBaseUrl+'assessment/survey-group/'+surveyGroupId+'/pdf/generate');
export const getSurveyGroupPdf = (surveyGroupId: any) => axios.get(apiBaseUrl+'assessment/survey-group/'+surveyGroupId+'/pdf');


